import React from 'react';
import { $Listutil, CheckerValidator, connect, EasyField } from 'react-antd-formutil';
import classlist from 'utils/classlist';
import { IUploaderType } from './types';
import UploaderItem, { FileItemType, IUploaderProps } from './UploaderItem';

export type { FileItemType } from './UploaderItem';
export interface IFileListProps {
    type: IUploaderType;
    isUploadFile?: boolean;
    // 最大条数
    maxCount?: number;
    name: string;
    isRequired?: boolean;
    hasError?: boolean;
    extra?: React.ReactNode;
    bottomExtra?: string;
    className?: string;
    parser?: (value: any[]) => string;
    bucket: IUploaderProps['bucket'];
    checker?: CheckerValidator;
}

const FileList: React.FC<IFileListProps> = ({
    type,
    isUploadFile,
    maxCount = 20,
    name,
    isRequired,
    hasError,
    extra,
    bottomExtra,
    className,
    parser,
    bucket,
    checker
}) => {
    const onAdd = ($listutil: $Listutil) => {
        if ($listutil.$length < maxCount!) {
            $listutil.$push();
        }
    };

    return (
        <div className={classlist('uploader-list-root', className)}>
            {extra && <div className="upload-extra">{extra}</div>}
            <div className="uploader-list">
                <EasyField type="list" $parser={parser} name={name} checker={checker}>
                    {($listutil: $Listutil<FileItemType>) => (
                        <UploaderItem
                            type={type}
                            isUploadFile={isUploadFile}
                            bucket={bucket}
                            name={name}
                            defaultValue={$listutil.$params}
                            onDelete={() => {
                                $listutil.$remove($listutil.$index).then($formutil => {
                                    const {
                                        $params: { list }
                                    } = $formutil;
                                    const isLast = list.every(item => item && item.url);

                                    if (list && list.length === maxCount! - 1 && isLast) {
                                        $listutil.$push();
                                    }
                                });
                            }}
                            onAdd={() => onAdd($listutil)}
                            isRequired={isRequired}
                            hasError={hasError}
                        />
                    )}
                </EasyField>
            </div>
            {bottomExtra && <div className="upload-extra upload-bottom-extra">{bottomExtra}</div>}
        </div>
    );
};

export default connect(FileList);
